/**
 * TanStack Query Client Setup
 * Global query client with rate limit handling
 */

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 5, // 5 minutes
            refetchOnWindowFocus: false,
            retry: 1,
        },
        mutations: {
            // Global retry with exponential backoff for rate limits
            retry: (failureCount, error: any) => {
                // Retry on rate limit errors (429)
                if (error?.status === 429 || error?.message?.includes('rate limit')) {
                    return failureCount < 5;
                }
                // Don't retry other errors
                return false;
            },
            retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 60000),
        },
    },
});

export default queryClient;
